import React from 'react';
import { StyledTextLabel } from '../StyledComponents';
import { FormattedMessage } from 'react-intl';

export const ActionsMessage = () => (
  <StyledTextLabel>
    <FormattedMessage id="mac.licenses.actions" defaultMessage="Actions" />
  </StyledTextLabel>
);
